// @ts-nocheck
import type { Requests } from '../../../../base/realtime-session';
import type { FeatureFlagsSubscriptions } from '../../../../types/server/modules/featureFlags/subscriptions';

export type * from '../../../../types/server/modules/featureFlags/subscriptions';

export const createSubscriptions = ( requests: Requests ): FeatureFlagsSubscriptions => ({
  FeatureFlags: ( params, onChange ) => {
          return requests.subscribe( `/feature-flags/:id?`, params, 'FeatureFlags', onChange );
          },
  OrgResolvedFlags: ( params, onChange ) => {
          return requests.subscribe( `/org-resolved-flags/:id?`, params, 'OrgResolvedFlags', onChange );
          }
});
